import _ from "lodash";
import { DashboardStyled } from "./Dashboard-styles";
import { getLocalstorage, saveParamMode } from "../../common/utils/other";
import PPRS from "./components/pprs";
import { SOURCE, TARGET } from "../../common/utils/const";
import ColleagueFinder from "./components/ColleagueFinder";
import { useEffect } from "react";

export default function Dashboard() {
  saveParamMode();
  const source = getLocalstorage(TARGET);

  return (
    <DashboardStyled>
      {
        source == SOURCE.PPRS ? <PPRS />
        :
        source == SOURCE.COLLEAUGE_FINDER && <ColleagueFinder></ColleagueFinder>
      }
    </DashboardStyled>
  );
}
